

const QuestionBankComponent = () => {
    return (
        <div>
            <p>Question-Bank</p>
        </div>
    )
}

export default QuestionBankComponent;
